import { client } from "../../../infrastructure/graphql/client";
import {
  GET_CPU_RAM_ANALYSIS,
  ANALYZE_ALL_VMS_CPU_RAM,
} from "../../../infrastructure/graphql/aiQueries/cpuRamAnalysisQueries";

export class CpuRamAnalysisService {
  async getCpuRamAnalysis(vmId) {
    try {
      const result = await client.query({
        query: GET_CPU_RAM_ANALYSIS,
        variables: { vmId },
        fetchPolicy: "network-only",
      });

      const response = result.data?.getCpuRamAnalysis;

      if (!response) {
        return {
          success: false,
          message: "No response from server",
          data: null,
        };
      }

      return {
        success: true,
        data: response,
      };
    } catch (error) {
      console.error("Get CPU RAM analysis error:", error);
      const errorMessage = error.graphQLErrors?.[0]?.message || "Network error";
      return {
        success: false,
        message: errorMessage,
        data: null,
      };
    }
  }

  async analyzeAllVmsCpuRam() {
    try {
      const result = await client.mutate({
        mutation: ANALYZE_ALL_VMS_CPU_RAM,
      });

      const response = result.data?.analyzeAllVmsCpuRam;

      if (!response) {
        return {
          success: false,
          message: "No response from server",
          data: null,
        };
      }

      return {
        success: true,
        data: response,
      };
    } catch (error) {
      console.error("Analyze all VMs CPU RAM error:", error);
      const errorMessage = error.graphQLErrors?.[0]?.message || "Network error";
      return {
        success: false,
        message: errorMessage,
        data: null,
      };
    }
  }
}